import { combineReducers } from 'redux-immutable';
import { Reducer } from 'redux';
import ui from './ui/reducer';

const rootReducer: Reducer = combineReducers({
  ui,
});

export default rootReducer;
